(function() {
  'use strict';

  angular
    .module('admin.lookup.service', [])
    .factory('LookupService', LookupService);

  /** @ngInject */
  function LookupService($http, $q, API) {

    function list(start, limit, t){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/collectibles/search/checklist?start=' + start + '&limit=' + limit + '&t=' + t)
        .success(defered.resolve);

      return defered.promise;
    }

    function addCollectibleToSegment(id, body){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/collectibles/' + id + '/checklist', body)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function numberOfPrintsOwnedByActiveUsers(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/collectibles/' + id + '/num_prints_by_active_users')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      list: list,
      addCollectibleToSegment: addCollectibleToSegment,
      numberOfPrintsOwnedByActiveUsers: numberOfPrintsOwnedByActiveUsers
    };

  }

})();
